import { SearchUseCase } from "@outschool/gql-frontend-generated";
import {
  EAST_ASIA_LOCALES,
  useLocale,
  useTranslation
} from "@outschool/localization";
import { onlineClassesPath } from "@outschool/routes";
import { useQueryWithPreviousData } from "@outschool/ui-apollo";
import {
  EnglishClassesByLevelCategories,
  searchListingsQuery,
  useShowCredits
} from "@outschool/ui-components-website";
import { TrackingPageSection } from "@outschool/ui-legacy-component-library";
import React from "react";

import { useListingActivitiesByUid } from "../hooks/Activity";
import { ActivitiesCarousel } from "./homepage/ActivitiesCarousel";
import { HeroEducators } from "./homepage/HeroEducators";
import { MembershipPlan } from "./homepage/MembershipPlan";
import { Testimonials } from "./homepage/Testimonials";
import { WhyChooseOutschool } from "./homepage/WhyChooseOutschool";

export default function BelowTheFoldLoggedOutUserHome() {
  const { t } = useTranslation("client\\components\\NewUserHome");
  const showCredits = useShowCredits();
  const locale = useLocale();
  const isEastAsia = EAST_ASIA_LOCALES.includes(locale);

  const { data: trendingActivitiesData, loading: trendingActivitiesLoading } =
    useQueryWithPreviousData(searchListingsQuery, {
      variables: {
        searchFilters: {
          q: "neurodiverse",
          order: "upcoming"
        },
        promotedRankingsEnabled: false,
        skipRating: false,
        withRecentReviews: false,
        includeMatchingSections: true,
        limit: 16,
        useCase: SearchUseCase.Discover
      }
    });

  const btsClassesPath = onlineClassesPath("back-to-school");

  const { listings: popularActivities, loading: popularActivitiesLoading } =
    useListingActivitiesByUid([
      "48034641-5263-40ee-86d0-9d5e744e8887",
      "236f98ea-288c-44e8-a745-9b250c01a35c",
      "a66c700e-0044-41f4-9296-9f5b2840f1de",
      "ea379261-1e15-4461-805e-5fe53f800802",
      "1b66c15b-023c-4a3a-96d2-45d890f424fd",
      "77fcda3c-a3bb-4a65-9f2c-dfc23486162c",
      "05b5554e-e607-44a9-b43b-10047905b9b9",
      "a07174c9-707f-436c-acda-947fc3345659",
      "3128c056-ea3a-4c09-adda-80ff01e78e5a",
      "32536616-8eb2-4146-b87b-ad31864f73f9",
      "6a724b5e-0f45-4295-8442-f9605b718e74",
      "e9a99571-af23-4b0b-ba37-1692d094fe40",
      "5a294e3a-163f-496a-a38a-750e70d77ff4",
      "762c2328-5ad1-405f-805f-13d0337661ad",
      "a69e7e55-7f20-407a-9f60-58da3e20d5fd",
      "62cf42a7-9497-41a6-a41e-4c876548e8b0",
      "329563d8-31ef-43fe-9383-3d7a7e5cf1ee",
      "bda00994-8ecd-4e15-baa2-da69e8034570",
      "0eca793c-8c60-48ac-aec0-e19de083b19d",
      "16dc404f-77ec-4fae-b115-e0edf88afe3e"
    ]);

  return (
    <>
      {isEastAsia && <EnglishClassesByLevelCategories />}
      <TrackingPageSection
        name="logged_out_hompage_popular_classes"
        uniqueId="logged_out_homepage_popular_classes"
      >
        {setImpressionNode => (
          <ActivitiesCarousel
            ref={setImpressionNode}
            listings={popularActivities || []}
            isLoading={popularActivitiesLoading}
            alwaysShown={true}
            title={t`Popular Classes`}
            trackingLabel={"popular_classes"}
            carouselRowNum={20}
            overrideShowCredits={showCredits}
            trackingName={"popular_classes_find_more_classes"}
            findMoreRedirectUrl={btsClassesPath}
          />
        )}
      </TrackingPageSection>
      <TrackingPageSection
        name="logged_out_homepage_why_choose_outschool"
        uniqueId="logged_out_homepage_why_choose_outschool"
      >
        {setImpressionNode => <WhyChooseOutschool ref={setImpressionNode} />}
      </TrackingPageSection>
      <TrackingPageSection
        name="logged_out_homepage_hero_educators"
        uniqueId="logged_out_homepage_hero_educators"
      >
        {setImpressionNode => <HeroEducators ref={setImpressionNode} />}
      </TrackingPageSection>
      <TrackingPageSection
        name="logged_out_homepage_testimonials"
        uniqueId="logged_out_homepage_testimonials"
      >
        {setImpressionNode => <Testimonials ref={setImpressionNode} />}
      </TrackingPageSection>
      <TrackingPageSection
        name="logged_out_homepage_trending_classes"
        uniqueId="logged_out_homepage_trending_classes"
      >
        {setImpressionNode => (
          <ActivitiesCarousel
            ref={setImpressionNode}
            listings={trendingActivitiesData?.searchListings?.listings || []}
            isLoading={trendingActivitiesLoading}
            alwaysShown={true}
            title={t`Trending Classes for neurodiverse learners`}
            trackingLabel={"trending_classes"}
            carouselRowNum={16}
            overrideShowCredits={showCredits}
            trackingName={"treding_classes_find_more_classes"}
          />
        )}
      </TrackingPageSection>
      <TrackingPageSection
        name="logged_out_homepage_membership_plan"
        uniqueId="logged_out_homepage_membership_plan"
      >
        {setImpressionNode => <MembershipPlan ref={setImpressionNode} />}
      </TrackingPageSection>
    </>
  );
}
